<template>
  <ul class="nav flex-column">
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link active" :href="profileUrl"
        ><i class="nav-icon fa fa-home"></i> Mein Profil</a
      >
    </li>
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link" href="/news">
        <i class="far fa-newspaper"></i> Neuigkeiten
        <span class="badge badge-primary">{{ unreadNews }}</span></a
      >
    </li>
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link" href="/profilbesucher">
        <i class="far fa-eye"></i> Profilbesucher
        <span class="badge badge-primary">{{
          unreadProfileVisitCount
        }}</span></a
      >
    </li>
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link" href="/freunde">
        <i class="fas fa-users"></i> Freunde
      </a>
    </li>
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link" href="/chat"
        ><i class="far fa-comments"></i> Nachrichten
        <span class="badge badge-primary">{{ unreadMessages }}</span></a
      >
    </li>
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link" href="/search-user">
        <i class="fas fa-search"></i> Mitgliedersuche</a
      >
    </li>
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link" href="/medien">
        <i class="far fa-images"></i> Meine Medien</a
      >
    </li>
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link" href="/kaufen"
        ><i class="fas fa-coins"></i> {{ currency }}
        <span v-if="balance !== null" class="badge badge-primary">{{
          balance
        }}</span></a
      >
    </li>
    <li class="nav-item">
      <a @click="checkAuth" class="nav-link" href="/Einstellungen">
        <i class="fas fa-cog"></i> Einstellungen</a
      >
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    profileName: {
      required: true,
      type: String
    }
  },
  created() {
    if (this.$store.getters["user/auth"]) {
      this.$store.dispatch("balance/read");
    }
  },
  computed: {
    profileUrl() {
      return "/mitglied/" + this.profileName;
    },
    currency() {
      return Laravel.lang.currency;
    },
    balance() {
      return this.$store.getters["user/auth"]
        ? this.$store.getters["balance/balance"]
        : null;
    },
    unreadMessages() {
      return this.$store.getters["user/auth"]
        ? this.$store.getters["user/unreadMessages"].length
        : 0;
    },
    unreadNews() {
      return this.$store.getters["user/auth"]
        ? this.$store.getters["user/unreadNews"]
        : 0;
    },
    unreadProfileVisitCount() {
      return Laravel.user
        ? Laravel.user.customer_profile.unreadProfileVisitCount
        : 0;
    }
  },
  methods: {
    checkAuth(event) {
      if (!this.$store.getters["user/auth"]) {
        event.preventDefault();
        event.stopPropagation();
        this.$store.dispatch("publicProfileModal/show", this.$modal);
        return false;
      }
    }
  }
};
</script>
